<template>
    <v-layout row wrap>

        <v-flex xs12 >
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{'Fault Comparison'|translate}}
                </v-card-title>

                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 md6>
                                    <v-autocomplete
                                            :items="rules"
                                            :label="'Rule'|translate"
                                            item-text="label"
                                            item-value="title"
                                            v-model="rule"
                                            @change="getData"
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            :items="floors"
                                            :label="'Floor'|translate"
                                            v-model="floor"
                                            @change="getData"
                                    ></v-autocomplete>
                                    <date-range-selector v-model="dateRange"  @change="handleDateChange()"></date-range-selector>
                                </v-flex>
                                <v-flex xs12 v-if="loading">
                                    <v-progress-linear :indeterminate="true"></v-progress-linear>
                                </v-flex>
                                <v-flex xs12 v-if="!loading">
                                    <vue-plotly v-if="othersFEData" disable-responsive :data="othersFEData" :layout="othersFELayout"
                                                ref="othersfeplot" @click="handleClick" :options="{}"/>
                                    <v-alert
                                            :value="alert"
                                            type="error"
                                    >
                                        {{alert}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>

                        </v-card-text>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from 'moment'
    import {getRule,callAPI} from '../helper'
    import VuePlotly from "../components/VuePlotly";
    import DateRangeSelector from "../components/DateRangeSelector";
    export default {
        name: 'FaultComparisson',
        components: {VuePlotly,DateRangeSelector},
        data () {
            return {
                menu:false,
                rule:null,
                alert:null,
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                currentRule:null,
                othersFEData:null,
                othersFELayout:null,
                rules:[],
                floor:null,
                floors:[],
                baseDate:  moment().subtract(31, "days"),
                endDate:  moment().subtract(1, "days"),
                dateRange:  {start:moment().subtract(1, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                loading:false,

            }
        },

        methods:{
            updateQueryString () {
                if(this.$router.currentRoute.name==="fault-comparison"){
                    this.$router.replace({
                        path: '/fault-comparison',
                        query: {
                            rangeStart:this.dateRange.start,
                            rangeEnd:this.dateRange.end,
                            floor:this.floor,
                            rule:this.rule,
                        }
                    }).catch(err => {})
                }
            },
            handleDateChange(){
                this.baseDate = moment(this.dateRange.start)
                this.endDate = moment(this.dateRange.end)
                this.getData()
            },
            handleClick(data){
                this.$router.push({
                    path: '/fault-analysis',
                    query: {
                        relevantVariables: this.currentRule.relevant_variables,
                        faultName: this.currentRule.title,
                        faultDesc: this.currentRule.desc,
                        rangeStart: this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                        rangeEnd: this.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
                        equipmentName: data.points[0].y
                    }
                })
            },
            getData(){
                let me=this;
                me.loading=true
                me.updateQueryString()
                me.alert=null
                me.othersFEData=null;
                me.othersFELayout=null;
                if(!me.rule||!me.floor){
                    me.loading=false
                    return
                }
                let myRule=null;
                for(let rule of me.rules){
                    if(rule.title==me.rule){
                        myRule=rule
                        break
                    }
                }
                me.currentRule=myRule
                let otherEquips=[]
                for (let i in me.$store.state.pointsListStore.pointsList.equipment_details) {
                    let otherEquip=me.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if (otherEquip.equipment_type===myRule.equipment_group&&otherEquip.floor===me.floor){
                        otherEquips.push(otherEquip)
                    }
                }
                if(otherEquips.length==0){
                    me.loading=false
                    me.alert=me.$options.filters.translate("No matching equipments")
                    return
                }
                otherEquips.sort((a, b) => (a.equipment_name < b.equipment_name) ? 1 : -1)
                callAPI('issue/',
                    {
                        'facility_name': me.$store.state.pointsListStore.pointsList.facility_name,
                        'issue': me.rule,
                        'equipment_name': otherEquips.map(x=>x.equipment_name),
                        'date_range': [me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                    }
                ).then(function (otherRes)
                {
                    let df=otherRes.data
                    if(!otherRes.data.equipment_id||otherRes.data.equipment_id.length==0){
                        me.loading=false
                        me.alert=me.$options.filters.translate("No Fault detected for this range and equipment")
                        return
                    }
                    let timeAxis=[];
                    let ts=moment(me.dateRange.start).format('YYYY-MM-DD HH:mm:ss')
                    let end=moment(me.dateRange.end).format('YYYY-MM-DD HH:mm:ss')
                    while (ts<=end){
                        timeAxis.push(ts)
                        ts=moment(ts).add(me.$store.getters.minutesBetweenSamples,'minutes').format('YYYY-MM-DD HH:mm:ss')
                    }
                    let refinedDf={
                        x:timeAxis,
                        y:otherEquips.map(x=>x.equipment_name),
                        z:[]
                    }
                    let yids=otherEquips.map(x=>x.equipment_id)
                    for (let eid of yids){
                        let newZ=new Array(timeAxis.length).fill(0);
                        for (let index in df['equipment_id']){
                            if(df['equipment_id'][index]===eid){
                                newZ[timeAxis.indexOf(df['timestamp'][index])]=1;
                            }
                        }
                        refinedDf.z.push(newZ)
                    }
                    if(!refinedDf.z[0]){
                        refinedDf.z[0]=new Array(timeAxis.length).fill(0)
                    }
                    me.othersFEData = [{
                        x: refinedDf.x,
                        y: refinedDf.y,
                        z: refinedDf.z,
                        type: 'heatmap',
                        showscale: false,
                        colorscale: [
                            [0, 'rgb(31, 119, 180)'],
                            [1, me.severityColors[myRule.severity]]
                        ]

                    }]
                    me.othersFELayout={
                        title:me.$options.filters.translate('Rule evaluation'),
                        height:Math.max(260,25*otherEquips.length),
                        yaxis: {
                            title: me.$options.filters.translate('Equipment'),
                            fixedrange: true,
                            type: 'category',
                            categoryorder: 'array',
                            categoryarray: otherEquips.map(x=>x.equipment_name),
                            showticklabels: true,
                            range: otherEquips.map(x=>x.equipment_name)
                        },
                        xaxis: {
                            title: me.$options.filters.translate('Time'),
                        },
                        margin:{
                            l:300
                        },
                        hoverlabel: { bgcolor: "#606060" },
                    }
                    me.loading=false
                })
            }
        },
        async beforeMount() {
            let preconf={...this.$route.query}
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(preconf.floor){
                this.floor=preconf.floor
            }
            if(preconf.rule){
                this.rule=preconf.rule
            }
            if(preconf.rangeStart&&preconf.rangeEnd){
                this.baseDate=moment(preconf.rangeStart)
                this.endDate=moment(preconf.rangeEnd)
                this.dateRange={start:preconf.rangeStart,end:preconf.rangeEnd}
            } else if(maxDate){
                this.baseDate=moment(maxDate).subtract(31, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            let rulescall=await getRule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            for (let rule of rulescall.result){
                rule.label=rule.equipment_group+" - "+rule.title
            }
            rulescall.result.sort((a, b) => (a.label > b.label) ? 1 : -1)
            this.rules=rulescall.result
            let floors=[]
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                let equip=this.$store.state.pointsListStore.pointsList.equipment_details[i]
                if(floors.indexOf(equip.floor)<0){
                    floors.push(equip.floor)
                }
            }
            floors.sort()
            this.floors=floors
            this.getData()
        }



    }
</script>
